<template>
  <v-container>
    <DesktopTopPart />
    <v-row>
      <v-col class="white px-0">
        <v-container fluid>
          <v-row>
            <DesktopLeftSidebar />
            <v-col class="grow pr-0">
              <!-- HotImagePlaceholder v-if="$store.state.progressSearching" / -->

              <MyLoader
                v-if="$store.state.progressSearching"
                :style="{
                  marginTop: '50px',
                }"
              />
              <List v-else />
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-row>
      <PageFooter />
    </v-row>
  </v-container>
</template>

<script>
import MyLoader from '@/components/App/_MyLoader'
import List from '@/components/List/List'
import DesktopLeftSidebar from '@/components/Views/Layout/DesktopLeftSidebar'
import DesktopTopPart from '@/components/Views/Layout/DesktopTopPart'
import PageFooter from '@/components/App/_PageFooter'
import HotImagePlaceholder from '@/components/Views/Home/HotImagePlaceholder.vue'

export default {
  name: 'HomePageDesktop',

  components: {
    HotImagePlaceholder,
    PageFooter,
    DesktopTopPart,
    DesktopLeftSidebar,
    List,
    MyLoader,
  },
}
</script>
